// import React from 'react';
// import styles from '../../../styles.module.css';
// import ReplaceTextFunction from '@/functions/ReplaceTextFunction';
// import { StatusRow } from '../../../StatusRow/StatusRow';

// export default function NoneViolationDetails({ rows }: { rows?: any }) {
//   return (
//     <div className={styles.detailRows}>
//       {Object.entries(rows).map(([key, value], index) => (
//         <StatusRow
//           key={key}
//           index={index}
//           compact
//           row={{
//             label: ReplaceTextFunction([key]),
//             value: value == null ? '-' : String(value),
//           }}
//         />
//       ))}
//     </div>
//   );
// }

// ==================

// import React, { Fragment } from 'react';
// import styles from '../../../styles.module.css';
// import ReplaceTextFunction from '@/functions/ReplaceTextFunction';
// import { StatusRow } from '../../../StatusRow/StatusRow';
// import Divider from '@/components/common/Divider';

// interface Props {
//   rows?: any;
//   depth?: number;
// }

// const MAX_DEPTH = 3;

// export default function NoneViolationDetails({ rows, depth = 0 }: Props) {
//   if (!rows || typeof rows !== 'object') return null;

//   return (
//     <div className={styles.detailRows} style={{ marginLeft: depth * 16 }}>
//       {Object.entries(rows).map(([key, value], index) => {
//         // Expand arrays recursively
//         if (Array.isArray(value) && depth < MAX_DEPTH) {
//           return (
//             <Fragment key={key}>
//               {/* <div style={{ fontWeight: 600, margin: '8px 0' }}>{ReplaceTextFunction([key])}</div> */}

//               {value.map((item, itemIndex) => (
//                 <Fragment key={`${key}-${itemIndex}`}>
//                   <NoneViolationDetails rows={item} depth={depth + 1} />

//                   {/* Divider between nested items only */}
//                   {itemIndex < value.length - 1 && <Divider className={`${styles.divider}`} />}
//                 </Fragment>
//               ))}
//             </Fragment>
//           );
//         }

//         return (
//           <StatusRow
//             key={key}
//             index={index}
//             compact
//             row={{
//               label: ReplaceTextFunction([key]),
//               value: value == null ? '-' : String(value),
//             }}
//           />
//         );
//       })}
//     </div>
//   );
// }

// =============

import React, { Fragment } from 'react';
import styles from '../../../styles.module.css';
import ReplaceTextFunction from '@/functions/ReplaceTextFunction';
import { StatusRow } from '../../../StatusRow/StatusRow';
import Divider from '@/components/common/Divider';
import { subCategoryIdList } from '@/api/global';
import { formatTehranPersianDate } from '@/functions/formatTehranPersianDate';

interface Props {
  response?: any;
  depth?: number;
  type?: string;
}

const MAX_DEPTH = 4;
function isIsoDateTime(value: unknown): value is string {
  if (typeof value !== 'string') return false;

  const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}$/;

  return isoRegex.test(value) && !isNaN(Date.parse(value));
}

function formatValue(value: unknown) {
  if (isIsoDateTime(value)) {
    // return new Date(value).toLocaleString('fa-IR');
    return formatTehranPersianDate(value);
  }

  return value;
}

export default function NoneViolationDetails({ response, depth = 0, type }: Props) {
  console.log('type==', type, response);

  // if (!rows || typeof rows !== 'object') return null;

  // console.log('type======', type, subCategoryIdList?.vehicle_card_and_document_status);

  const rows =
    type === subCategoryIdList?.vehicle_card_and_document_status &&
    response &&
    Object.keys(response).length > 0
      ? (() => {
          const { card_type, card_status, document_type, ...rest } = response;

          return {
            ...rest,
            card_type: card_type?.description ?? '-',
            card_status: card_status?.description ?? '-',
            document_type: document_type?.description ?? '-',
          };
        })()
      : // : response;
        (() => {
          const { pilgrimage, price, ...rest } = response ?? {};
          if (price) {
            return { ...rest, price: price ? Number(price)?.toLocaleString() : null };
          } else {
            return { ...rest };
          }
        })();

  if (!rows || typeof rows !== 'object') return null;
  const entries = Object.entries(rows);
  console.log('rows========', rows);
  // console.log('rows========', rows, ReplaceTextFunction('1', type));
  return (
    <div
      className={styles.detailRows}
      //  style={{ marginLeft: depth * 16 }}
    >
      {entries.map(([key, value], index) => {
        const hasNextItem = index < entries.length - 1;
        // Handle arrays
        if (Array.isArray(value) && depth < MAX_DEPTH) {
          return (
            <Fragment key={key}>
              {value.length === 0 ? (
                <StatusRow
                  index={index}
                  compact
                  row={{
                    label: ReplaceTextFunction(key, type),
                    value: '-',
                  }}
                />
              ) : (
                value.map((item, itemIndex) => (
                  <Fragment key={`${key}-${itemIndex}`}>
                    <NoneViolationDetails response={item} depth={depth + 1} type={type} />

                    {(itemIndex < value.length - 1 || hasNextItem) && (
                      <Divider className={styles.divider} />
                    )}
                  </Fragment>
                ))
              )}
            </Fragment>
          );
        }

        // Handle nested objects
        if (value && typeof value === 'object' && !Array.isArray(value) && depth < MAX_DEPTH) {
          return (
            <Fragment key={key}>
              {Object.keys(value).length === 0 ? (
                <StatusRow
                  index={index}
                  compact
                  row={{
                    label: ReplaceTextFunction(key, type),
                    value: '-',
                  }}
                />
              ) : (
                <>
                  <NoneViolationDetails response={value} depth={depth + 1} type={type} />
                  {hasNextItem && <Divider className={styles.divider} />}
                </>
              )}
            </Fragment>
          );
        }

        // Primitive values
        return (
          <StatusRow
            key={key}
            index={index}
            compact
            row={{
              label: ReplaceTextFunction(key, type),
              // value:
              //   value == null
              //     ? '-'
              //     : ReplaceTextFunction(typeof value === 'number' ? value : String(value), type),
              value:
                value == null
                  ? '-'
                  : ReplaceTextFunction(
                      typeof formatValue(value) === 'number'
                        ? formatValue(value)
                        : String(formatValue(value)),
                      type,
                    ),
            }}
          />
        );
      })}
    </div>
  );
}
